/**
 * MM Composition Diagram Manager - Moon Moon Agency
 * Synchronise les bulles numérotées du diagramme avec la carte feature affichée (desktop)
 * et fait défiler le carousel jusqu'à la carte correspondante (mobile)
 */

/*********************************************************************************************
 * 🔧 MM COMPOSITION DIAGRAM MANAGER
 */
const MMCompositionDiagramManager = {
	config: {
		selectors: {
			container: '[data-mm-composition]',
			bubble: '[data-mm-composition-bubble]',
			card: '[data-mm-composition-card]',
			cardDesktop: '[data-mm-composition-card].mm-composition__card--desktop',
			cardMobile: '[data-mm-composition-card].mm-composition__card--mobile',
			carousel: '.mm-composition__carousel',
			packPanel: '[data-mm-composition-product]',
			packMattressChecked: 'input[name="pack-step-step_1"]:checked',
			packCard: '[data-pack-funnel-card]',
		},
		classes: {
			active: 'is-active',
		},
	},

	/**
	 * Initialize the module
	 */
	init() {
		const containers = window.getElements(this.config.selectors.container);
		if (!containers.length) return; // Guard clause : sortie silencieuse si absent du DOM

		containers.forEach((container) => this._bindEvents(container));
		this._initPackSync();
		window.log('info', '🔧 [MM_COMPOSITION_DIAGRAM]', 'Initialized', { count: containers.length });
	},

	_initPackSync() {
		const panels = window.getElements(this.config.selectors.packPanel);
		if (!panels.length) return;

		const checkedInputs = window.getElements(this.config.selectors.packMattressChecked);
		const lastChecked = checkedInputs[checkedInputs.length - 1];
		const productId = lastChecked?.closest(this.config.selectors.packCard)?.dataset.productId;
		if (productId) this._showPackPanel(panels, productId);

		document.addEventListener('global:pack-selection-changed', (e) => {
			if (e.detail.stepId !== 'step_1' || !e.detail.productId) return;
			this._showPackPanel(panels, e.detail.productId);
		});
	},

	_showPackPanel(panels, productId) {
		panels.forEach((panel) => {
			panel.toggleAttribute('hidden', panel.dataset.mmCompositionProduct !== String(productId));
		});
	},

	_bindEvents(container) {
		container.addEventListener('click', (e) => {
			const bubble = e.target.closest(this.config.selectors.bubble);
			if (!bubble || !container.contains(bubble)) return;

			this.select(container, bubble.dataset.mmCompositionIndex);
		});
	},

	/**
	 * Rejoue le reveal (mm-motion.js) sur une carte réaffichée. La carte vient
	 * de perdre [hidden] dans le même tick : retirer/rajouter .mm-in tout de
	 * suite ne laisse pas au navigateur l'occasion de peindre l'état de départ,
	 * donc la transition ne se déclenche pas. Deux rAF imbriqués forcent ce
	 * frame de peinture intermédiaire avant de relancer l'animation.
	 */
	_replayReveal(card) {
		card.classList.remove('mm-in');
		window.requestAnimationFrame(() => {
			window.requestAnimationFrame(() => {
				card.classList.add('mm-in');
			});
		});
	},

	select(container, index) {
		const bubbles = container.querySelectorAll(this.config.selectors.bubble);
		const desktopCards = container.querySelectorAll(this.config.selectors.cardDesktop);
		const mobileCards = container.querySelectorAll(this.config.selectors.cardMobile);

		bubbles.forEach((bubble) => {
			const isActive = bubble.dataset.mmCompositionIndex === index;
			bubble.classList.toggle(this.config.classes.active, isActive);
			bubble.setAttribute('aria-pressed', String(isActive));
		});

		desktopCards.forEach((card) => {
			const isActive = card.dataset.mmCompositionIndex === index;
			card.classList.toggle(this.config.classes.active, isActive);
			card.toggleAttribute('hidden', !isActive);
			if (isActive) {
				this._replayReveal(card);
			}
		});

		let targetMobileCard = null;
		mobileCards.forEach((card) => {
			const isActive = card.dataset.mmCompositionIndex === index;
			card.classList.toggle(this.config.classes.active, isActive);
			if (isActive) targetMobileCard = card;
		});

		if (targetMobileCard) {
			const carousel = container.querySelector(this.config.selectors.carousel);
			if (carousel) {
				carousel.scrollTo({ left: targetMobileCard.offsetLeft, behavior: 'smooth' });
			}
		}

		window.emit('global:composition-diagram-changed', { index });
	},
};

// Auto-init avec vérification readyState
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => MMCompositionDiagramManager.init());
} else {
	MMCompositionDiagramManager.init();
}
